import { useState, useCallback } from 'react'
import { supabase } from '../../shared/lib/supabase'

export default function useVerifyReview({ reviewId, onVerified, onDelivered } = {}) {
  const [verifying, setVerifying] = useState(false)
  const [delivering, setDelivering] = useState(false)
  const [error, setError] = useState(null)

  const authFetch = async (path, body) => {
    const session = (await supabase.auth.getSession()).data.session
    const res = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session?.access_token || ''}`
      },
      body: JSON.stringify(body || {})
    })
    if (!res.ok) {
      const b = await res.json().catch(() => ({}))
      throw new Error(b.error || `${res.status} ${res.statusText}`)
    }
    return res.json()
  }

  const verify = useCallback(async (justification) => {
    if (!reviewId) return
    setVerifying(true); setError(null)
    try {
      const result = await authFetch(`/api/insurance-review/${reviewId}/verify`, { justification })
      onVerified?.(result)
    } catch (err) {
      setError(err?.message || 'Verify failed')
    } finally {
      setVerifying(false)
    }
  }, [reviewId, onVerified])

  const deliver = useCallback(async (target) => {
    if (!reviewId) return
    if (!target) {
      setError('Delivery target is required')
      return
    }
    setDelivering(true); setError(null)
    try {
      const result = await authFetch(`/api/insurance-review/${reviewId}/deliver`, { target })
      onDelivered?.(result)
    } catch (err) {
      setError(err?.message || 'Deliver failed')
    } finally {
      setDelivering(false)
    }
  }, [reviewId, onDelivered])

  return { verifying, delivering, error, verify, deliver }
}
